import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { trackEvent } from 'utilities/analytics';

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_ENTRA_CLIENT_ID,
    authority: process.env.REACT_APP_ENTRA_AUTHORITY,
    redirectUri: process.env.REACT_APP_ENTRA_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: '/',
    knownAuthorities: [
      new URL(process.env.REACT_APP_ENTRA_AUTHORITY || 'https://login.microsoftonline.com').hostname,
    ],
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: (process.env.REACT_APP_ENTRA_SCOPES || 'openid email profile').split(' '),
};

export const msalInstance = new PublicClientApplication(msalConfig);

// GA4: report auth lifecycle. We only emit `login` on the redirect-completion
// event (not on token-silent renewals), so each session is counted once.
// `login_failure` captures interaction errors so we can correlate auth issues
// with usage drops.
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
    trackEvent('login', { method: 'azure_ad' });
  } else if (event.eventType === EventType.LOGIN_FAILURE) {
    trackEvent('login_failure', {
      method: 'azure_ad',
      error_code: event.error?.errorCode || 'unknown',
    });
  }
});
